import { Observable } from 'rxjs';

import {
  InventoryItem,
  InventoryItemFilters,
  ListInventoryItemsResponse,
  DemandReport,
  PanelAvailabilityList,
  PanelAvailabilityZone,
  PanelResolution,
  ResetZonePayload,
  SetZonePanelsPayload,
  StockReport,
  SupplyChainAnalyticsStatus,
  SupplyChainRegenerateResponse,
  SupplyChainReportKey,
} from '../../../interfaces/supply-chain.interface';

/** Único punto de acceso a Supply Chain (`/supply-chain` y `/quotes/panel-availability`). Clase abstracta: es el token de inyección. */
export abstract class SupplyChainApiService {
  abstract listItems(
    filters: InventoryItemFilters,
    page: number,
  ): Observable<ListInventoryItemsResponse>;

  /** Solo `is_active`: el resto del artículo lo manda Terralink cada noche. */
  abstract setItemActive(id: number, isActive: boolean): Observable<InventoryItem>;

  /** Zonas con sus paneles en orden; vive en la Sales API porque la consulta el cotizador. */
  abstract listPanelAvailability(): Observable<PanelAvailabilityList>;

  /** Paneles de la zona de una cotización, en su orden. */
  abstract resolvePanels(
    stateCode: string,
    municipalityCode?: string | null,
  ): Observable<PanelResolution>;

  /** Fija a mano los paneles de una zona; desde ahí el nocturno no la toca. */
  abstract setZonePanels(payload: SetZonePanelsPayload): Observable<PanelAvailabilityZone>;

  /** Regresa la zona al cálculo automático; esa noche el nocturno la recalcula. */
  abstract resetZone(payload: ResetZonePayload): Observable<unknown>;

  /** Switch, días generados y corridas recientes de cada reporte */
  abstract analyticsStatus(): Observable<SupplyChainAnalyticsStatus>;

  /**
   * Lee un reporte precalculado; no recalcula.
   *
   * @param between - Rango `'<ISO UTC>,<ISO UTC>'` con extremos en medianoche CDMX
   */
  abstract demandReport(between: string): Observable<DemandReport>;
  abstract stockReport(between: string): Observable<StockReport>;

  /** Encola la regeneración: un job por mes; las existencias solo admiten hoy */
  abstract regenerateReport(
    report: SupplyChainReportKey,
    between: string,
  ): Observable<SupplyChainRegenerateResponse>;
}
